import * as io from 'socket.io-client'
import { MsgBusConnectConfig, MsgBusProvider } from './msg-bus-provider';

export class SocketIoProvider implements MsgBusProvider{
    private socket: any;
    private listeners: any = {}

    connect(config: MsgBusConnectConfig): Promise<void> {
        this.socket = io(config.url, {
            transports: ['websocket'],
            query: {
                ...(config.query || {}),
                token: config.token || {}
            }
        });

        return new Promise<void>((resolve, reject) => {
            this.socket.on('connect', () => {
                resolve();
            });
            this.socket.on('connect_error', error => {
                reject(error);
            });
        });
    }

    subscribe<T = any>(eventName: string, callback: (arg: T) => void): void {
        if(!this.socket){
            throw new Error('socket.IO connection was not started');
        }

        this.unsubscribe(eventName);

        const handler = (raw: T) => {
            let parsed;
            try {
                if (typeof raw === 'string'){
                    parsed = JSON.parse(raw);
                }
                else{
                    parsed = raw;
                }
            }
            catch(err){
                console.error(`[Msg-Bus-Provider] Json parsed Failed`, raw);
                return;
            }
            callback(parsed);
        }

        this.listeners[eventName] = handler;
        this.socket.on(eventName, handler);
      }

      unsubscribe(eventName: string): void {
        if(!this.socket){
            return;
        }
        const handler = this.listeners[eventName];

        if(handler){
            this.socket.off(eventName, handler);
            delete this.listeners[eventName];
        }
      }
    
      disconnect(): void {
        Object.keys(this.listeners).forEach(eventName => {
          this.unsubscribe(eventName);
        });

        if(this.socket){
            this.socket.disconnect();
            this.socket = null;
        }
      }
}